import { useState, useEffect } from 'react'

function useTabVisibility() {
  const [isTabActive, setIsTabActive] = useState(() => {
    // Ensure the hook works during SSR by checking if document is defined
    if (typeof document !== 'undefined') {
      return document.visibilityState === 'visible'
    } else {
      return true // or false, depending on your default state preference
    }
  })

  useEffect(() => {
    // Avoid adding event listeners during SSR
    if (typeof document === 'undefined') {
      return
    }

    const handleVisibilityChange = () => {
      setIsTabActive(document.visibilityState === 'visible')
    }

    document.addEventListener('visibilitychange', handleVisibilityChange)

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange)
    }
  }, [])

  return isTabActive
}

export default useTabVisibility
